import React from 'react'
import  { useState } from "react";
import toast from "react-hot-toast";
import { issuedBookF } from "../../../../services/operations/bookDetais";
import { useSelector } from 'react-redux';

function IssuedBook({issuedBook}) {

    const { token } = useSelector((state) => state.auth);

    const [issudFormData, setissuedFormData] = useState({
        bookID: "",
        libraryId: "",
        bookIssuedDate: "",
      });
    
      function issuedchangeHandler(event) {
        const { name, value, checked, type } = event.target;
        setissuedFormData((prevState) => {
          return {
            ...prevState, // copy old input field data
    
            
    
            [name]: type === "checkbox" ? checked : value,
    
          
          };
        });
      }
      const issuedBookHandler = async (event) => {
    
        event.preventDefault();
        // console.log(issudFormData)
        const toastID = toast.loading("loading");
    
        try {
          await issuedBookF(issudFormData, token);
          setissuedFormData({
            bookID: "",
            libraryId: "",
            bookIssuedDate: "",
          });
        } catch (error) {
          console.log(error.message);
          toast.error("Cannot issued book ");
        }
        toast.dismiss(toastID);
      };

  return (
    <div>   
    
     <div>
    <form onSubmit={issuedBookHandler}>
     <p className={`text-center py-10 text-2xl font-mulish font-bold underline transition-all ${issuedBook ? "opacity-100" : "opacity-0"}`}>Issued Book</p>
       <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
         {/*  Student Library Id*/}
         <div className="flex flex-col space-y-2  lg:lg:w-[27%]  w-full md:w-[47%]">
           <label className="text-sm text-richblack-900" htmlFor="ilibraryId">
             Student Library Id <sup className="text-red">*</sup>
           </label>
           <input
             id="libraryId"
             name="libraryId"
             type="text"
             placeholder="Student Library Id"
             onChange={issuedchangeHandler}
             value={issudFormData.libraryId}
             className="two-style "
           />
         </div>
         {/* Book ID */}
         <div className="flex flex-col space-y-2  lg:lg:w-[27%]  w-full md:w-[47%]">
           <label className="text-sm text-richblack-900" htmlFor="bookID">
             Book Id <sup className="text-red">*</sup>
           </label>
           <input
             type="text"
             id="bookID"
             name="bookID"
             placeholder="Book Id"
             onChange={issuedchangeHandler}
             value={issudFormData.bookID}
             className="two-style "
           />
         </div>
         {/* book issued Date */}

         <div className="flex flex-col space-y-2  lg:lg:w-[27%]  w-full md:w-[47%]">
           <label
             className="text-sm text-richblack-900"
             htmlFor="bookIssuedDate"
           >
            Book Issued Date <sup className="text-red">*</sup>
           </label>
           <input
             id="bookIssuedDate"
             name="bookIssuedDate"
             type="date"
             placeholder="Student Library Id"
             onChange={issuedchangeHandler}
             value={issudFormData.bookIssuedDate}
             className="two-style "
           />
         </div>
       </div>
       <button 
             className="bg-yellow-50 mt-7 p-2 font-mulish font-bold rounded-lg hover:bg-yellow-25 transition-all "
             type="submit"> issued Book</button>
     </form>
    </div>
    </div>
  )
}

export default IssuedBook